import { Record } from 'immutable';
import TradeIn from 'commons-general/models/TradeIn/TradeInModel.js';

const LeadRecord = Record({
    depositCreation: {
        websiteId: '',
        vehicleInventoryId: null,
        contactInfo: {
            phone: ' ',
            email: ' ',
            firstName: ' ',
            lastName: ' ',
        },
        stripeToken: '',
    },
    depositAmount: 0,
    tradeIns: new TradeIn(),
    evaluationQuestionsValue: '',
    stripeChargeId: '',
    leadType: '',
    leadInfo: '',
    leadCarInfo: {
        vehicleTrimId: 0,
        vehicleId: 0,
        vehicleInventoryId: 0,
        info: '',
    },
});

class Lead extends LeadRecord {}

export default Lead;
